"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _space = _interopRequireDefault(require("../../styles/space"));

var quoteDefaults = {
  columnWidthNoImage: [10, 10, 8, 8, 8],
  columnWidthWithImage: [12, 8, 8, 8, 8],
  copyFontWeight: 'bold',
  copyMarginBottom: _space.default.small,
  justifyQuoteGrid: 'left',
  alignQuoteGrid: 'flex-start',
  quoteCopyFontSize: 'large',
  quoteDetailsFontSize: 'medium',
  showQuotation: true,
  textAlignImage: 'left',
  textAlignNoImage: 'left',
  wrapperPaddingMobile: _space.default.xlarge,
  wrapperPaddingDesktop: _space.default.xxxlarge,
  quoteIconSizeDesktop: '17rem',
  quoteIconTopDesktop: '-3.5rem',
  noImageIcon: ''
};
var quote = {
  horizon: _objectSpread({}, quoteDefaults),
  lionsCreativity: _objectSpread(_objectSpread({}, quoteDefaults), {}, {
    columnWidthNoImage: [12, 10, 8, 8, 10],
    copyFontWeight: 'normal',
    copyMarginBottom: _space.default.base,
    justifyQuoteGrid: 'center',
    quoteCopyFontSize: 'xxlarge',
    showQuotation: false,
    textAlignNoImage: 'center'
  }),
  money2020: {
    wrapperPaddingMobile: _space.default.base,
    wrapperPaddingDesktop: _space.default.large,
    quoteCopyFontSize: 'medium',
    quoteDetailsFontSize: 'small',
    quoteIconSizeDesktop: '12rem',
    quoteIconTopDesktop: '-2rem',
    columnWidthNoImage: '12',
    showQuotation: false,
    noImageIcon: '"',
    alignQuoteGrid: 'center'
  }
};
var _default = quote;
exports.default = _default;